import { render, staticRenderFns } from "./DeleteLogs.vue?vue&type=template&id=70391867"
import script from "./DeleteLogs.vue?vue&type=script&lang=js"
export * from "./DeleteLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports